<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />

    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :selectable="false"
    >
      <template #cell(fullName)="data">
        <b-media vertical-align="center">
          <template #aside>
            <img-with-no-image-error
              :src="data.item.doctorImage"
              :alt="data.item.title"
              height="70px"
              width="70px"
              :class="'img-list-thumbnail'"
            />
          </template>
          {{ $t('specialists.doctor') }} {{ data.item.fullName }}
        </b-media>
      </template>

      <template #leftHeader>
        <button
          class="btn btn-primary"
          @click="addItem"
        >
          <span class="text-nowrap">{{ $t('specialists.sync') }}</span>
        </button>
      </template>
    </BDataTable>
  </div>
</template>

<script>
import {
  BMedia,
} from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import ImgWithNoImageError from '@/components/img-with-no-image-error.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useSpecialistsList from './useSpecialistsList'

export default {
  name: 'SpecialistsList',
  components: {
    BDataTable,
    BMedia,
    ImgWithNoImageError,
    LayoutLoading,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      fetchList,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      addItem,
    } = useSpecialistsList()

    return {
      changeLanguage,
      currentLanguage,
      fetchList,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      addItem,
    }
  },
}
</script>
